import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Api} from '../../providers/api';
import {NgxSpinnerService} from 'ngx-spinner';
import {NgbDropdownConfig} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-grupo',
  templateUrl: './modal-grupo.component.html',
  styleUrls: ['./modal-grupo.component.css']
})
export class ModalGrupoComponent implements OnInit {

  @Output()
  onclose = new EventEmitter();

  @Output()
  onsuccess = new EventEmitter<any>();

  @Input()
  action;

  @Input()
  item;

  nombre;
  nombre_validar;

  value = null;

  constructor(config: NgbDropdownConfig, private api: Api, private spinner: NgxSpinnerService) {
    config.autoClose = true;

  }

  ngOnInit() {
    console.log(this.item);
    this.nombre_validar = this.nombre = this.item.value ? this.item.value.nombre : null;
  }

  close() {
    this.onclose.emit();
  }

  success() {
    const value = this.item.value;
    value.nombre = this.nombre;
    this.onsuccess.emit(value);
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/modal-grupo/modal-grupo.component.ts